import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const folderNameMap: any = {
  "simple-dyte-client": "simpleDyteClient",
  "custom-layout": "customLayout",
};

const { REACT_APP_MY_BACKEND: MY_BACKEND } = process.env;

export const MainScreenComponent = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [allMeeetings, setAllMeeting] = useState<any[]>([]);
  const [newMeetingTitle, setNewMeetingTitle] = useState<string>("");
  const [selectedExample, setSelectedExample] =
    useState<string>("simple-dyte-client");

  let navigate = useNavigate();
  let rooms = [
    "Showroom",
    "Presentation Room",
    "Conference Room",
    "Private Room",
    "Sales Room",
  ];

  // const handleCreateRoomClick = useCallback(
  //   (title: string) => {
  //   const apiKEY = process.env.REACT_APP_DYTE_API_KEY;
  //   const orgID = process.env.REACT_APP_DYTE_ORG_ID;
  //   const baseURL = process.env.REACT_APP_DYTE_API_BASE_URL;
  //    const meetingURL = `${baseURL}/v1/organizations/${orgID}/meeting`;
  //     axios({
  //       url: meetingURL,
  //       method: "POST",
  //       headers: {
  //          Authorization: `APIKEY ${apiKEY}`,
  //       },
  //       data: {
  //         title: { title: title || `YEP-${ Math.random().toString(36).substring(6)}` },
  //       },
  //     })
  //       .then((res) => {
  //         let rooms = [...allMeeetings];
  //         rooms.push(res.data.data.meeting);
  //         setAllMeeting([...rooms]);
  //         setNewMeetingTitle("");
  //       })
  //       .catch((err) => console.error(err));
  //   },
  //   [allMeeetings]
  // );

  const joinRoom = async (
    meetingId: string,
    roomName: string,
    title: string,
    isHost: boolean = false
  ) => {
    //     const apiKEY = process.env.REACT_APP_DYTE_API_KEY;
    // const orgID = process.env.REACT_APP_DYTE_ORG_ID;
    // const baseURL = process.env.REACT_APP_DYTE_API_BASE_URL;
    //   const resp = await axios({
    //     url: `${baseURL}/organizations/${orgID}/meetings/${meetingId}/participant`,
    //     method: "POST",
    //     headers: {
    //       Authorization: `APIKEY ${apiKEY}`,
    //     },
    //     data: {

    //       clientSpecificId: Math.random().toString(36).substring(7)
    //     },
    //   });

    //   const authResponse = resp.data.data.authResponse;
    //   const authToken = authResponse.authToken;

    //   //saving meeting details in session storage
    //   sessionStorage.setItem("auth", authToken);
    //   sessionStorage.setItem("meetingID", meetingId);
    //   sessionStorage.setItem("roomName", roomName);

    // redirecting to the example meeting page
    navigate(`/lobby/${title}/${roomName}/${meetingId}`);
  };

  useEffect(() => {
    // api call to get list of available/existing meeting rooms
    const apiKEY = process.env.REACT_APP_DYTE_API_KEY;
    console.log(
      "🚀 ~ file: mainScreen.tsx ~ line 81 ~ useEffect ~ apiKEY",
      apiKEY
    );
    const orgID = process.env.REACT_APP_DYTE_ORG_ID;
    const baseURL = process.env.REACT_APP_DYTE_API_BASE_URL;
    console.log(`${baseURL}/organizations/${orgID}/meetings`);
    axios({
      url: `${baseURL}/organizations/${orgID}/meetings`,
      method: "GET",
      headers: { Authorization: `APIKEY ${apiKEY}` },
    })
      .then((response) => {
        let aa: any[] = [];
        response.data.data.meetings.forEach((element: any) => {
          if (rooms.includes(element.title)) aa.push(element);
        });
        setAllMeeting(aa);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="main-screen-wrapper">
      <div className="existing-meeting-wrapper flex column ">
        <div className="existing-meeting-list flex row">
          {!loading &&
            allMeeetings.map((el, k) => {
              return (
                <div key={el.id} className="flex column meeting-list-wrapper">
                  <button
                    onClick={() => joinRoom(el.id, el.roomName, el.title, true)}
                  >
                    {el.title}
                  </button>
                </div>
              );
            })}
        </div>
        {!loading && !allMeeetings.length && (
          <div className="flex no-rooms column">
            <div>No existing rooms 🙁 !</div>
            <div>Create a new room above</div>
          </div>
        )}
        {loading && (
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        )}
      </div>
    </div>
  );
};
